import createTypedReducer from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

export interface OrderFile {
    file?: File;
}

export type CustomOrderFileUploadState = Readonly<OrderFile>;

export const initialOrderFileUploadState: CustomOrderFileUploadState = {
    file: undefined,
};

export const customOrderFileUploadReducer = createTypedReducer(initialOrderFileUploadState, {
    "Custom/OrderFileUpload/AddFile": (draft: Draft<CustomOrderFileUploadState>, { file }: { file: File }) => {
        return {
            ...draft,
            file,
        };
    },

    "Custom/OrderFileUpload/ClearFiles": (draft: Draft<CustomOrderFileUploadState>) => {
        return {
            ...draft,
            file: undefined,
        };
    },
});
